<script setup lang="ts">
import { ref, useId } from 'vue';

const name = ref<string>(useId());
</script>

<template>
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g :clip-path="`url(#${name}clip0)`">
      <path
        d="M3.27344 19.9468L5.60188 22.2753C6.3403 23.0137 7.56813 22.8989 8.1569 22.0364L14.5049 12.7373"
        stroke="#12B37D"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path opacity="0.3" d="M2.4375 35.7812H12.0208" stroke="#14004D" stroke-width="2.5" stroke-linecap="round" />
      <path
        d="M19.0939 19.6965C21.6867 16.0634 24.5182 13.1628 26.9751 11.4016C28.2071 10.5185 29.306 9.94952 30.2045 9.69908C31.112 9.44617 31.681 9.54946 32.0207 9.79185C32.3603 10.0342 32.643 10.5388 32.6989 11.4792C32.7542 12.4103 32.5734 13.6346 32.1388 15.0866C31.2721 17.9827 29.4497 21.6034 26.8569 25.2366C24.2641 28.8698 21.4327 31.7703 18.9757 33.5315C17.7437 34.4147 16.6448 34.9836 15.7463 35.2341C14.8389 35.487 14.2698 35.3837 13.9302 35.1413C13.5905 34.8989 13.3078 34.3944 13.2519 33.4539C13.1966 32.5228 13.3774 31.2987 13.812 29.8465C14.6787 26.9504 16.5011 23.3298 19.0939 19.6965Z"
        fill="#DCDAE5"
        stroke="#988FB3"
        stroke-width="1.66667"
      />
      <path
        d="M19.193 16.8042C22.5547 12.0951 26.2269 8.32393 29.4231 6.0248C31.0257 4.87204 32.4702 4.11782 33.6661 3.78115C34.8714 3.44187 35.6878 3.55986 36.2057 3.92947C36.7235 4.29914 37.1006 5.03275 37.1716 6.28285C37.242 7.52319 36.9985 9.1345 36.4294 11.0248C35.2943 14.795 32.9201 19.4931 29.5596 24.2034C29.5377 24.218 29.4534 24.258 29.2223 24.2507C28.8831 24.2398 28.3981 24.1272 27.7853 23.8922C26.571 23.4266 25.0668 22.5653 23.6354 21.5437C22.2039 20.5221 20.9003 19.3798 20.0652 18.3828C19.6435 17.8794 19.3787 17.4572 19.2582 17.1399C19.143 16.8365 19.2082 16.7761 19.193 16.8042Z"
        fill="#5C2EE6"
        stroke="#462C93"
        stroke-width="1.66667"
      />
      <path
        d="M15.5064 35.7405C14.9377 36.5375 13.249 37.6439 12.5142 37.1195C11.7793 36.595 11.9276 35.1274 12.8453 33.8414C13.4667 32.9707 16.0752 34.9436 15.5064 35.7405Z"
        fill="#14004D"
      />
      <path
        d="M35.376 3.69936C31.564 0.978899 24.2864 4.641 19.1211 11.8789"
        :stroke="`url(#${name}paint0_linear)`"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        :id="`${name}paint0_linear`"
        x1="19.8558"
        y1="9.65504"
        x2="30.7394"
        y2="0.99949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#988FB3" />
        <stop offset="1" stop-color="#462C93" />
      </linearGradient>
      <clipPath :id="`${name}clip0`">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
